import Common from '../common.js';

export default {
    elements: function (query, sectionIds, active, validOnDate, start, page, count, sortField, sortDir, async, successCallback, errorCallback, fields) {
        var queryParams = '?';
        if (query != null) {
            queryParams += 'query=' + query + '&';
            queryParams += 'queryFields=text&'
        }
        if (sectionIds != null) {
            queryParams += 'sectionIds=' + sectionIds + '&';
        }
        if (active != null) {
            queryParams += 'active=' + active + '&';
        }
        if (validOnDate != null) {
            queryParams += 'validOnDate=' + validOnDate + '&';
        }
        if (start != null) {
            queryParams += 'start=' + start + '&';
        }
        if (page != null) {
            queryParams += 'page=' + page + '&';
        }
        if (count != null) {
            queryParams += 'count=' + count + '&';
        }
        if (sortField != null) {
            queryParams += 'sortField=' + sortField + '&';
        }
        if (sortDir != null) {
            queryParams += 'sortDir=' + sortDir + '&';
        }

        if (fields != null) {
            queryParams += fields + '&';
        }

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/content/element' + queryParams,
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },
    element: function (id, async, successCallback, failCallback) {
        var result = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/content/element/by-external-id/' + id,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');
                try {
                    if (failCallback != null) {
                        failCallback();
                    }
                }
                catch (e) {
                }

            }
        });

        return result;
    },

    getElementById: function (id, includeSectionPattern) {
        var queryParams = id + '?';
        if (includeSectionPattern != null) {
            queryParams += 'includeSectionPattern=' + includeSectionPattern;
        }

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/content/element/' + queryParams,
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json',
            xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
            }
        });

        if (d != null) {

        }

        return d;
    },
};


// WEBPACK FOOTER //
// ./src/api/content.js